module.exports = __webpack_public_path__ + "static/img/img8.6fed1566.png";